import {createStateMaker} from '@shared/helpers/object'

import {DetailPaymentClass, InterestFreeInstallmentType, InterestFreeInstallmentTypeType} from '@web/core/constants'

import {AdmissionDetailState, PaymentStatus} from '../interface'

export const getInitialState = (): AdmissionDetailState => ({
    id: '',
    date: '',
    status: PaymentStatus.COMPLETION,
    usedPaymentMethod: {},
    pay: {
        orderRepurchaseAvailable: false,
        rewardPointPayAmount: 0,
        chargePointPayAmount: 0,
        rechargePointAmount: 0,
        promotionApplyAmount: 0,
        payLaterAmount: 0,
        generalPayAmount: 0,
        giftCardAmount: 0,
        totalPayAmount: 0,
    },
    receipts: [],
})

export const getCardInterestType = ({
    freeInterestInstallment,
    partFreeInterestInstallment,
}: {
    freeInterestInstallment: boolean
    partFreeInterestInstallment: boolean
}): InterestFreeInstallmentTypeType => {
    if (partFreeInterestInstallment) {
        return InterestFreeInstallmentType.PART
    } else if (freeInterestInstallment) {
        return InterestFreeInstallmentType.ALL
    }
    return InterestFreeInstallmentType.NONE
}

export const getRefundInitialState = (): Required<AdmissionDetailState>['refund'] => {
    return {
        amount: {
            totalAmount: 0,
            productAmount: 0,
            deductedAmount: 0,
            alternativeAmount: 0,
            authenticationType: DetailPaymentClass.NONE,
            amountByPaymentMethod: {
                rewardPointAmount: 0,
                chargedPointAmount: 0,
                chargeAmount: 0,
                cardPromotionPointAmount: 0,
                cardAmount: 0,
                bankAmount: 0,
                virtualAccountAmount: 0,
                mobileAmount: 0,
                payLaterAmount: 0,
                familyPayAmount: 0,
                generalPayAmount: 0,
                generalPayMeansClassType: DetailPaymentClass.NONE,
                giftCardAmount: 0,
            },
        },
    }
}

export const getGeneralPayAmount = (paymentMethodAmount: {easyCard?: number; easyBank?: number}) => {
    if (paymentMethodAmount?.easyCard) {
        return paymentMethodAmount.easyCard
    }
    if (paymentMethodAmount?.easyBank) {
        return paymentMethodAmount.easyBank
    }
    return 0
}

export const getGeneralPayClassType = (paymentMethodAmount: {easyCard?: number; easyBank?: number}) => {
    if (paymentMethodAmount?.easyCard) {
        return DetailPaymentClass.CREDIT_CARD_EASY_PAY
    }
    if (paymentMethodAmount?.easyBank) {
        return DetailPaymentClass.BANK_EASY_PAY
    }
    return DetailPaymentClass.NONE
}

export const makeMock = createStateMaker<AdmissionDetailState>(getInitialState)
